// extracted by mini-css-extract-plugin
export default {"container":"p6BFk5prF4xyDvakPo2d"};